<template>
  <span
    class="clipboard-icon"
    :data-clipboard-text="loc"
    @click="trekSocial()"
  >
    <svg viewBox="0 0 35 35" width="34" height="34" xmlns="http://www.w3.org/2000/svg"><path d="M24.506 16.166l-3.337 3.336a4.716 4.716 0 0 1-6.67 0 4.716 4.716 0 0 1-.717-.952l1.55-1.55c.074-.074.165-.117.252-.167.107.366.294.713.582 1a2.36 2.36 0 0 0 3.336 0l3.335-3.335a2.36 2.36 0 0 0 0-3.336 2.36 2.36 0 0 0-3.335 0l-1.187 1.187c-.962-.374-2-.475-3.009-.327l2.528-2.527a4.718 4.718 0 0 1 6.672 6.67zm-8.34 8.34a4.719 4.719 0 0 1-6.671-6.672l3.335-3.336a4.718 4.718 0 0 1 6.672 0c.29.29.518.615.716.952L18.668 17c-.074.073-.164.115-.251.166a2.338 2.338 0 0 0-.583-1 2.36 2.36 0 0 0-3.336 0l-3.336 3.336c-.92.92-.92 2.416 0 3.336.92.92 2.417.92 3.336 0l1.187-1.187c.962.374 2 .476 3.01.327l-2.529 2.528zM17 0C7.611 0 0 7.611 0 17s7.611 17 17 17 17-7.611 17-17S26.389 0 17 0z" fill="#FF6E6E" fill-rule="evenodd"/></svg>
  </span>
</template>

<script>
import ClipboardJS from 'clipboard'
import { EventBus } from '@/EventBus'
import { trekSocial } from '@/utils/trek'

export default {
  name: 'ClipboardIcon',
  data () {
    return {
      loc: 'https://app.nos.nl/op3/kiesrecht/index.html'
    }
  },
  mounted () {
    const clipboard = new ClipboardJS('.clipboard-icon')

    clipboard.on('success', e => {
      EventBus.$emit('success')
      e.clearSelection()
    })
  },
  methods: {
    trekSocial () {
      trekSocial('copy')
    }
  }
}
</script>

<style lang="scss" scoped>
.clipboard-icon {
  height: 46px;
  width: 46px;
  margin: 0 8px;
  display: inline-block;
  vertical-align: middle;
  font-size: 0;
  cursor: pointer;

  svg {
    height: 46px;
    width: 46px;
  }
}
</style>
